/* eslint-disable @typescript-eslint/no-explicit-any */
import { requestApi } from "../lib/http";

export const Asset = (url: string): any => {
  return {
    upload: (payload: any) => {
      const path = `${url}/upload`;

      return requestApi({
        method: "POST",
        path: path,
        body: payload,
      });
    },
  };
};
